import { filter } from 'rxjs/operators';
import { GlobalServiceService } from "./shared/services/global-service.service";
import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, ApplicationRef, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { MessagingServiceService } from "./shared/services/messaging-service.service";
import { Subscription } from 'rxjs';

declare var gtag;
@Component({
    selector: "dc-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {

  title = "dentalchat-beta";
  showLoader = false; // Initialize as false to prevent initial flash
  c_url: any;
  last_urls_str: any;
  message: any;
  private window: Window;
  private initialized = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private global: GlobalServiceService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private msgService: MessagingServiceService,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
    }
    
    // Configure Google Analytics
    const navEndEvents = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    
    const navSubscription = navEndEvents.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (typeof gtag !== "undefined") {
          gtag('config', 'G-DC3345LJ72', {
            'page_path': event.urlAfterRedirects
          });
        }
      }
    });
    
    this.subscriptions.push(navSubscription);
  }

  ngOnInit() {
    // Prevent double initialization
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    // Subscribe to loader state with proper handling
    const loaderSubscription = this.global.showLoader.subscribe(res => {
      const shouldShow = res === 1;
      if (this.showLoader !== shouldShow) {
        this.showLoader = shouldShow;
        this.cdr.detectChanges();
      }
    });
    
    this.subscriptions.push(loaderSubscription);

    // Initialize messaging service only in browser
    if (isPlatformBrowser(this.platformId)) {
      // Use setTimeout to ensure DOM is ready and prevent initialization conflicts
      setTimeout(() => {
        this.msgService.requestPermission();
        this.msgService.receiveMessage();
      }, 100);
    }
  }

  ngOnDestroy() {
    // Clean up subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  changeOfRoutes(event) {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
      
      const loginSubscription = this.global.is_front_logged.subscribe(res => {
        if (res != 0) {
          const body = document.getElementsByTagName("body")[0];
          body.classList.add("dashboard_chatbox");
        } else {
          const body = document.getElementsByTagName("body")[0];
          body.classList?.remove("dashboard_chatbox");
        }
      });
      
      this.subscriptions.push(loginSubscription);
    }
  }
}
